export const hy = {
    "n1": "Գլխավոր էջ",
    "n2": "Պատվիրել",
    "n3": "գործարք",
    "n4": "թիմը",
    "n5": "իմը",
    "t1": "ինչ-որ բան սխալ է եղել",
    "t2": "Հաջողությամբ պատճենվեց",
    "t3": "Խնդրում ենք լրացնել տեղեկատվությունը ամբողջությամբ",
    "t4": "Բեռնվում է…",
    "t5": "Մուտքը հաջողվեց",
    "t6": "Ներկայացման համար գնահատականը պետք է լինի 3-ից մեծ",
    "t7": "Ներկայացումը հաջողվեց",
    "t8": "Անբավարար մնացորդ, հնարավոր չէ ստանալ",
    "t9": "Ներկայացումը ձախողվեց",
    "t10": "Խնդրում ենք նախ կապել հասցեն, և դուք կվերահղվեք դեպի անձնական կենտրոնի էջ:",
    "t11": "Հասցեն ամրացված է, խնդրում ենք կապվել հաճախորդների սպասարկման ծառայության հետ՝ այն փոփոխելու համար:",
    "t12": "Փոփոխությունը հաջողվեց",
    "t13": "Փոփոխությունը ձախողվեց",
    "t14": "Խնդրում ենք կապվել հաճախորդների սպասարկման ծառայության հետ՝ ձեր գաղտնաբառը փոխելու համար",
    "t15": "Գաղտնաբառի ձևաչափի սխալ",
    "t16": "Հաջողությամբ հանել",
    "t17": "Առավելագույն գումարը, որը կարող է հանվել",
    "t18": "Նվազագույն դուրսբերում",
    "t19": "Երկու գաղտնաբառերը անհամապատասխան են",
    "t20": "Խորհուրդներ",
    "t21": "Անհնար է ցատկել այս պահին",
    "t22": "Գաղտնաբառի ձևաչափի սխալ",
    "t23": "Գրանցումը հաջողվեց",
    "t24": "Խնդրում ենք մուտքագրել տարածքի կոդը",
    "t25": "Ոչ ավելին",
    "l1": "լեզուն",
    "l2": "Խնդրում ենք մուտքագրել հաշվի համարը",
    "l3": "Խնդրում ենք մուտքագրել գաղտնաբառը",
    "l4": "հիշիր",
    "l5": "Մուտք գործել",
    "l6": "Գնացեք գրանցվելու համար",
    "l7": "Ոչ մի հաշիվ",
    "l8": "Բջջային հեռախոսահամար",
    "l9": "Մականուն",
    "l10": "Գաղտնաբառ",
    "l11": "Հաստատեք գաղտնաբառը",
    "l12": "Հրավերի կոդը",
    "l13": "Գրանցվել",
    "l14": "Արդեն ունեք հաշիվ",
    "l15": "Գնալ դեպի մուտք",
    "l16": "Խնդրում ենք մուտքագրել 6-16 նիշանոց գաղտնաբառ",
    "bz1": "օգնություն",
    "bz2": "ՀՏՀ",
    "bz3": "առևտրի կանոններ",
    "bz4": "Ինչպես գումար հանել",
    "bz5": "Ինչպես լիցքավորել",
    "bz6": "1. Ի՞նչ է TikTokShop-ը:",
    "bz7": "TiktokShop-ը շուկայավարման խթանման ընկերություն է, որն օգնում է TiktokShop առցանց խանութի առևտրականներին ամբողջ աշխարհում ստանալ ավելի շատ պատվերներ և ավելացնել TiktokShop առցանց խանութի զննարկման տվյալները: Մենք հավատարիմ ենք TiktokShop-ի, առևտրականների և սպառողների միջև եռակողմ շահութաբեր շուկայավարման և առաջխաղացման մոդելի ստեղծմանը: Համակցված վերջին P2P բլոկչեյն տեխնոլոգիայի հետ՝ սպառողները և առևտրականները արագորեն միանում են USDT-ի միջոցով (TRC20, ERC20): Գրանցված օգտվողները կարող են ստանալ միջնորդավճար պատվերների համար, մինչդեռ առևտրականները կարող են ավելացնել իրենց խանութի վաճառքի տվյալները: Սա շահույթի վերջին մոդելն է ինտերնետ բլոկչեյնի մոդելում:",
    "bz8": "2. Ինչպե՞ս է աշխատում TiktokShop-ը:",
    "bz9": "TiktokShop-ի ամենօրյա արձագանքները ցույց են տալիս, որ բարելավման կարիք ունեցող ապրանքները վաճառվում են TiktokShop-ում: Օգտագործողները միայն պետք է հեշտությամբ սեղմեն պատվերի վրա, և համակարգը ավտոմատ կերպով ստեղծում է պատվերի բաժանորդագրություն: Օգտատերերը վճարում են պատվերի գումարը blockchain USDT-ի միջոցով և ստանում օրական միջնորդավճարներ:",
    "bz10": "3. Ինչու՞ են նույն արժույթի գները տարբեր երկու գործարքներում:",
    "bz11": "Գնային տարբերությունները պայմանավորված են բոլոր գործոններով, որոնք չեն նպաստում արժույթների ազատ շրջանառությանը, ներառյալ արժույթի փոխանցումների արագությունը, ցանցի պայմանները, արժույթի մուտքի սահմանափակումները, տարբեր տարածաշրջանների մարդկանց կողմից արժույթի ճանաչումը և նույնիսկ փոխանակման, գործարքների և այլնի կողմից տրամադրվող առևտրային զույգերի տեսակները: Հետևաբար, նույն արժույթը կարող է գների տարբերություններ ունենալ տարբեր գործարքներում:",
    "bz12": "4. Ներդրումային շահույթ.",
    "bz13": "Որքան բարձր է ստացված ապրանքի գինը, այնքան բարձր է շահույթը, որը դուք ստանում եք պատվերի ժամանակ: Միևնույն ժամանակ, TiktokShop-ը պատահականորեն բաժանում է մեծ միջնորդավճարների պատվերներ։",
    "bz14": "Ամեն օր համակարգը ավտոմատ կերպով ստեղծում և բաժանում է 60 ապրանքի պատվեր օգտատերերին: Օգտագործողները յուրաքանչյուր պատվերի համար վճարում են USDT-ի միջոցով և ստանում են 0,6% միջնորդավճար: Հանձնաժողովի մեծ պատվերները նշանակվում են պատահականության սկզբունքով:",
    "bz15": "USDT-ը կարող է հանվել 60 պատվերից հետո: (Եթե 60 պատվեր չկատարվի, համակարգը ինքնաբերաբար կդադարի մինչև օրվա մնացած պատվերները)",
    "bz16": "Յուրաքանչյուր հաշիվ կարող է կապված լինել միայն մեկ USDT հաշվի հետ: Եթե ​​սխալ է տեղի ունենում, խնդրում ենք կապվել հաճախորդների սպասարկման հետ:",
    "bz17": "Ամենօրյա պատվերների առաքումն ավարտելուց հետո կարող եք գումար վերցնել սովորական եղանակով։ Գումարը կհասնի դուրսբերումը սկսելուց հետո 24 ժամվա ընթացքում, և դուրսբերման սահմանափակում չկա:",
    "bz18": "Նախքան լիցքավորումը, խնդրում ենք կապել ձեր դուրսբերման հասցեն (աջակցում է TRC-20) USDT հասցեն: Դուք կարող եք սեղմել վերալիցքավորման վրա APP-ի կամ վեբ էջում և ընտրել բլոկչեյնը (TRC-20), որն օգտագործում եք լիցքավորելու համար:",
    "bz19": "Փոխադարձ լիցքավորում կամ փոխադարձ փոխանցում չի թույլատրվում հարակից հաշիվների միջև: Սա պատվեր գրավելու չարամիտ վարք է և լրջորեն ազդում է հարթակի շահագործման կանոնների վրա: Եթե ​​նման վարքագիծ հայտնաբերվի, համակարգը անմիջապես կսառեցնի հաշիվը և որակազրկի աշխատանքը:",
    "bz20": "Կապակցված հաշիվները պետք է կատարեն պատվերի առաջադրանքները յուրաքանչյուր օրվա հաշվում, որպեսզի կարողանան շարունակել թարմացնել պատվերի առաջադրանքները հաջորդ օրվա համար: Եթե ​​կապակցված հաշիվներից մեկն ունի անավարտ առաջադրանք, այն կդադարեցնի պատվերի առաջադրանքների թարմացումը: Պատվերի առաջադրանքները չեն կարող թարմացվել մինչև պատվերի բոլոր առաջադրանքները չավարտվեն:",
    "bz21": "Վերալիցքավորումը կամ փոխանցումը կապված հաշիվների միջև չի թույլատրվում: Սա չարամիտ պատվեր գրավելու վարքագիծ է, որը լրջորեն ազդում է հարթակի գործառնական կանոնների վրա: Եթե ​​նման վարքագիծ հայտնաբերվի, համակարգը կտուգանի հաշիվը: Առաջին տույժը հաշվի միջոցների 15%-ն է։ Պատվերների կողոպուտի կրկնվող չարամիտ վարքագիծն ուղղակիորեն կզրկվի ձեզ աշխատանքից:",
    "ty1": "Լավ",
    "ty2": "Չեղարկել",
    "ty3": "Ներկայացրե՛ք",
    "ty4": "TRC20 հասցե",
    "ty5": "ERC20 հասցե",
    "s1": "Կուտակային եկամուտ",
    "s2": "սպասարկում",
    "s3": "Մեր մասին",
    "s4": "օգնություն",
    "s5": "Գործընկերներ",
    "s6": "իմ ծառայությունները",
    "d1": "Ավարտված չէ",
    "d2": "Ավարտված",
    "d3": "Տվյալներ դեռ չկան",
    "d4": "Պատվերի համարը",
    "d5": "առևտրի ժամերը",
    "d6": "Գումարը",
    "d7": "Առաջադրանքների ընթացիկ քանակը",
    "d8": "ակնկալվող վերադարձ",
    "d9": "Դեռ պետք է",
    "d10": "Վարկանիշ",
    "j1": "Հաշվի մնացորդը",
    "j2": "Առևտրի ներածություն",
    "j3": "TiktokShop-ն ամեն օր օգտագործում է TiktokShop-ի հետադարձ կապը՝ ցուցադրելու TiktokShop-ի կողմից վաճառվող ապրանքները, որոնք բարելավման կարիք ունեն: Օգտագործողները միայն պետք է սեղմեն պատվերի վրա, և համակարգը ավտոմատ կերպով կստեղծի պատվերի ստորագրություն: Օգտատերերը պատվերի գումարը վճարում են USDT բլոկչեյնի միջոցով և կարող են ամեն անգամ ստանալ ավելի քան 0,6% միջնորդավճար, իսկ համակարգը պատահականորեն բաշխում է մեծ պարգևների պատվերներ։",
    "j4": "Սկսեք համընկնել",
    "j5": "Այսօրվա վաստակը",
    "j6": "Ավարտված",
    "j7": "Առաջադրանքների ընդհանուր քանակը",
    "td1": "հավասարակշռություն",
    "td2": "հանձնաժողով",
    "td3": "ստանալ",
    "td4": "մարդկանց ընդհանուր թիվը",
    "td5": "Օգտատեր",
    "td6": "Նպաստել",
    "td7": "Քանակ",
    "td8": "Կարգավիճակ",
    "g1": "Կանխիկ գումար հանել",
    "g2": "Վերալիցքավորում",
    "g3": "Հրավիրեք ընկերներին",
    "g4": "Հրավիրեք հիմա",
    "g5": "Ձեր ընկերների գրանցումից հետո ստացած յուրաքանչյուր շահույթի դիմաց դուք կստանաք համապատասխան միջնորդավճար:",
    "g6": "անձնական տվյալներ",
    "g7": "Հիմնադրամի մանրամասները",
    "g8": "Վերալիցքավորման ռեկորդ",
    "g9": "Կանխիկացման գրառումներ",
    "g10": "լեզուն",
    "g11": "Դուրս գալ",
    "g12": "Իսկապե՞ս ուզում եք դուրս գալ:",
    "yh1": "Օգտագործողի մասին տեղեկություններ",
    "yh2": "Փոփոխել",
    "yh3": "կարգավորումները",
    "yh4": "հեռախոս",
    "yh6": "Բնօրինակ գաղտնաբառը",
    "yh7": "նոր գաղտնաբառ",
    "mx1": "Հանձնաժողովի հավաքածու",
    "mx2": "եկամուտը",
    "mx3": "Հրաժարումը մերժվել է",
    "mx4": "ժամանակ",
    "mx5": "Վերալիցքավորումը հաջողվեց",
    "mx6": "Մերժված է",
    "mx7": "Սպասվում է",
    "mx8": "Կանխիկացման հասցեն",
    "mx9": "հասանելի մնացորդը",
    "mx10": "Իրական ժամանումը",
    "mx11": "Խնդրում ենք մուտքագրել դուրսբերման գումարը",
    "cz2": "Պատճենել",
    "cz3": "Fiat արժույթի ընտրություն",
    "cz4": "վճարել",
    "cz5": "Ավանդի հասցեն աջակցում է միայն TRC20-USDT, իսկ ավանդի նվազագույն գումարը 20USDT է:",
    "cz6": "Ավանդի հասցեն աջակցում է միայն ERC20-ին, իսկ ավանդի նվազագույն գումարը 20USDT է:",
    "cz1": "Ավանդի հասցեն աջակցում է միայն ERC20-ին, իսկ ավանդի նվազագույն գումարը 20USDT է:",
    "qy1": "տարածքային կոդը",
    "yq1": "Հրավիրեք ընկերներին",
    "yq2": "Հրավերի կոդը",
    "yq3": "Հրավիրեք ընկերներին և վայելեք հսկայական առավելություններ",
    "yq4": "Գնա և հրավիրիր",
    "zf1": "Վերալիցքավորման մեթոդ",
    "zf2": "Խնդրում ենք ընտրել վերալիցքավորման եղանակ",
    "zf3": "առևտրային արժույթ",
    "zf4": "առևտրային ցանց",
    "zf5": "Գնացեք առևտրի",
    "zf6": "Հաջողությամբ պատճենվեց",
    "zf7": "առևտրային արժույթ",
    "zf8": "Խնդրում ենք օգտագործել",
    "zf9": "Գումար փոխանցեք ստորև նշված հասցեին՝ լիցքավորումն ավարտելու համար:",
    "zf10": "Գործարքի արժույթ",
    "zf11": "Պատճենել",
    "zf12": "Խնդրում ենք ուշադիր ստուգել հասցեն: Եթե ​​այն սխալ փոխանցեք, չեք կարողանա առբերել այն:",
    "zf13": "Ժամանման ժամանակը",
    "zf14": "Մոտ 1-5 րոպե",
    "zf15": "Վերալիցքավորման նվազագույն գումարը",
    "a1": "Խանութի շուկայավարման կենտրոն",
    "a2": "«Tik Shop» խանութի մարքեթինգային կենտրոնը բոլորովին նոր բաժին է, որը նախատեսված է օգնելու վաճառականներին կարճ ժամանակահատվածում արագորեն բարձրացնել իրենց արտադրանքի վաճառքի և գովասանքի դրույքաչափերը՝ դրանով իսկ ավելացնելով ապրանքների քաշը և հետագայում մեծացնելով դրանց բացահայտումը: օգտատերերն օգնում են առևտրականներին՝ կատարելով տարբեր առաջադրանքներ և ստանալ համապատասխան պարգևներ՝ այդպիսով ձեռք բերելով շահեկան իրավիճակ երկու կողմերի համար:",
    "a3": "Ներկայումս համակարգն ունի 40 միլիոն օգտատեր և 5 միլիոն վաճառող, իսկ հարթակում ամեն օր գովազդվող ապրանքների թիվը հասնում է 80 միլիոնի; Առևտրային որոշ ապրանքներ 60%-ով ավելացրել են խանութների վաճառքները՝ միանալով մարքեթինգային կենտրոնի համակարգին. մարքեթինգային կենտրոնի համակարգի և հարթակի օգտագործողներին անհրաժեշտ է միայն սեղմել պատվերի վրա, և մարքեթինգային կենտրոնի համակարգը ավտոմատ կերպով կստեղծի պատվերի ստորագրություն: Օգտատիրոջ պատվերի գումարը կանխավճարից հետո վիրտուալ գործարքն ավարտվում է, և դրամական միջոցներն անմիջապես վերադարձվում են օգտատիրոջ հաշվին: Ամեն անգամ կարելի է լրացուցիչ միջնորդավճար ստանալ 0,6%-ից ավելի: Համակարգը նաև պատահականորեն կհատկացնի մեծ պարգևների պատվերներ՝ օգտվողների միջնորդավճարը բարձրացնելու համար:",
    "a4": "Tik Shop-ը մեծ նշանակություն է տալիս օգտատերերի և առևտրականների կարիքներին և շարունակում է օպտիմալացնել և կատարելագործել մարքեթինգային կենտրոնի համակարգը։"
  }
  